<article class="onboarding-notification" [class.onboarding-notification--new]="notification.isNew"
    (click)="onItemClick()" role="button" tabindex="0" (keydown.enter)="onItemClick()"
    (keydown.space)="$event.preventDefault(); onItemClick()">
    <div class="onboarding-notification__icon" aria-hidden="true">
        <mat-icon>inventory_2</mat-icon>
    </div>

    <div class="onboarding-notification__body">
        <div class="onboarding-notification__header">
            <h4 class="onboarding-notification__title">
                {{ 'notification.onboarding_potential_cases' | translate }}
            </h4>
            @if (notification.isNew) {
            <span class="onboarding-notification__badge">
                {{ 'notification.new' | translate }}
            </span>
            }
        </div>

        <p class="onboarding-notification__summary">
            {{ displayMessage }}
        </p>

        <div class="onboarding-notification__footer">
            <time class="onboarding-notification__time">
                {{ notification.receivedAt | date: 'short' }}
            </time>
            <span class="onboarding-notification__hint">
                {{ 'notification.Click to manage claims' | translate }}
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </div>
    </div>

    <button mat-icon-button type="button" class="onboarding-notification__dismiss" (click)="onDelete($event)"
        [matTooltip]="'notification.delete_notification' | translate"
        [attr.aria-label]="'notification.delete_notification' | translate">
        <mat-icon>close</mat-icon>
    </button>
</article>
